export default __webpack_public_path__ + "static/Metal_Fence_Foundation-247512af4ab1b7628f59b3b2a1646248.png";